import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { App } from '@df/core/app';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { Product } from '../product.decorator';
/**
 * Displays product description
 */
@Component({
    selector: 'product-view-description',
    templateUrl: './product-view-description.html',
    styleUrls: ['./product-view-description.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, TranslationModule, SizeClassDirective]
})
export class ProductViewDescriptionComponent extends UiComponent {
    showLongDescription = false;
    /**
     * App
     */
    app = inject(App);
    /**
     * Description
     */
    @Input()
    product?: Product<IProductDataV3>;

    toggle() {
        this.showLongDescription = !this.showLongDescription;
        this.detectChanges();
    }
}
